import { CardType } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

const APPLE_PAY_TO_CARD_TYPE_MAPPING: Record<string, CardType> = {
  debit: CardType.DEBIT,
  credit: CardType.CREDIT,
  prepaid: CardType.PREPAID,
  store: CardType.UNKNOWN,
}

export const normalizeApplePayCardType = (type: string): CardType => {
  return APPLE_PAY_TO_CARD_TYPE_MAPPING[type] ?? CardType.UNKNOWN
}
